"use client";

import { IconButtonProceedToCheckout } from "@repo/assets/images";
import { useSnackbarContext } from "@repo/contexts/SnackbarContext";
import { useBeginCheckout } from "@repo/lib/hooks/gtm";
import { useTrackCheckoutStarted } from "@repo/lib/hooks/webengage";
import { Button } from "@repo/ui";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import NProgress from "nprogress";
const ProceedToCheckoutButton = ({
  hasOutOfStock,
  closeMinicart,
  cart,
  locale
}) => {
  const t = useTranslations("Common");
  const router = useRouter();
  const {
    setSnackbar
  } = useSnackbarContext();
  const {
    handleBeginCheckoutEvent
  } = useBeginCheckout();
  const {
    trackCheckoutStartedEvent
  } = useTrackCheckoutStarted();
  const handleProceed = async () => {
    if (!hasOutOfStock) {
      handleBeginCheckoutEvent(cart);
      trackCheckoutStartedEvent(cart);
      NProgress.start();
      router.push(`/${locale}/checkout`);
      if (closeMinicart) {
        closeMinicart();
      }
    } else {
      setSnackbar({
        open: true,
        message: t("Cart_Message_Out_Of_Stock"),
        type: "error"
      });
    }
  };
  return <>
      <Button onClick={handleProceed} size="md" className="flex w-full items-center justify-center font-semibold" variant="primary" data-sentry-element="Button" data-sentry-source-file="ProceedToCheckoutButton.jsx">
        <IconButtonProceedToCheckout className="text-button-primary-iconColor me-3" data-sentry-element="IconButtonProceedToCheckout" data-sentry-source-file="ProceedToCheckoutButton.jsx" />
        {t("Proceed_To_Checkout")}
      </Button>
    </>;
};
export default ProceedToCheckoutButton;